import React from "react";
import styled from "styled-components";
import { AnimateAppearanceWrapper } from "../../../../components/animate-appearence/AnimateAppearanceWrapper";
import { PageTitle } from "../../../../components/ui-kit";
import CustomersTable from "../components/CustomersTable";
import { useGetCustomers } from "../hooks/useCustomers";

const Container = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ details }) => details && "margin-top: 30px;"}
`;

const TopLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

const TableContainer = styled.div<{ details?: boolean }>`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  ${({ details }) =>
    !details &&
    `border: 1px solid #eeeeee;
    border-radius: 10px;
    padding: 30px 20px;`}
  box-sizing: border-box;

  @media (max-width: 900px) {
    padding: ${({ details }) => (details ? "0" : "12px")};
  }
`;

export interface CustomersListProps {
  ownerId?: string;
  details?: boolean;
}

export const CustomersList: React.FunctionComponent<CustomersListProps> = ({
  ownerId,
  details,
}) => {
  const { customers, onPaginationChange, totalDocs, limit, page } =
    useGetCustomers(ownerId);

  return (
    <AnimateAppearanceWrapper>
      <Container details={details}>
        <TopLine>
          <PageTitle title="Customers" />
        </TopLine>
        <TableContainer details={details}>
          <CustomersTable
            data={customers}
            pagination={{ page, limit, totalDocs, onPaginationChange }}
          />
        </TableContainer>
      </Container>
    </AnimateAppearanceWrapper>
  );
};
